// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbl_a"};